import HomePage from '../components/home/HomePage'

export default function OverviewRoute() {
  return <HomePage />
}
